import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NbDialogService, NbMenuItem, NbMenuService } from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import ReportSpam from "../../../models/report-spam.model";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { filter } from "rxjs/operators";
import Exercise from "../../../models/exercise.model";
import { ExerciseService } from "../../../services/exercise.service";
import { DialogExerciseComponent } from "../../dialog-exercise-content/dialog-exercise-content.component";

@Component({
  selector: "ngx-view-exercise",
  styleUrls: ["./view-exercise.component.scss"],
  templateUrl: "./view-exercise.component.html",
})
export class ViewExerciseComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() exercise: Exercise;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];

  constructor(
    public userService: UserService,
    private exerciseService: ExerciseService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.exercise.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  loadContent(value) {
    this.isMore = value;
  }

  loadButtonAction(item) {
    if (item.createdBy === this.uid) {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/exercise/${this.exercise.id}`,
        },
      ];
    } else {
      this.menuItems = [
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/exercise/${this.exercise.id}`,
        },
      ];
    }
  }

  report(item: ReportSpam) {
    this.onDelete.emit(item.refId);
  }

  doExercise() {
    this.router.navigateByUrl(`/exercise/${this.exercise.id}`);
  }

  navigateRef(item) {
    if (item.courseId != "") {
      this.router.navigateByUrl(`/course/${item.courseId}`);
    } else if (item.quizId != "") {
      this.router.navigateByUrl(`/quiz/${item.quizId}`);
    }
  }

  tagSelected(tag) {
    console.log("tagSelected:", tag);
  }

  delete(id) {
    if (!this.submitted) {
      this.submitted = true;
      this.dialogService
        .open(DialogYesNoPromptComponent, {
          context: {
            title: "Bạn có chắc xóa nội dung này?",
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
            this.loading = true;
            this.exerciseService
              .delete(id)
              .then((result) => {
                this.loading = false;
                this.submitted = false;
                this.onDelete.emit(id);
              })
              .catch((err) => {
                this.loading = false;
                this.submitted = false;
              });
          }
          this.submitted = false;
        });
    }
  }

  edit(item: Exercise) {
    let lecBk = new Exercise();
    lecBk = clone(item);
    this.dialogService
      .open(DialogExerciseComponent, {
        context: {
          header: "Cập nhật thử thách",
          mode: "edit",
          exercise: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.exercise = value;
          this.onEdit.emit(value);
        }
      });
  }
}
